/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import {
	B100,
	B50,
	G100,
	G50,
	N40,
	N70,
	P50,
	P75,
	R100,
	R50,
	T100,
	T75,
	Y200,
	Y75,
} from '@atlaskit/theme/colors';

export const gradients = [
	`270deg, ${N40} 0%, ${N70} 100%`,
	`270deg, ${R50} 0%, ${R100} 100%`,
	`270deg, ${P50} 0%, ${P75} 100%`,
	`270deg, ${B50} 0%, ${B100} 100%`,
	`270deg, ${T75} 0%, ${T100} 100%`,
	`270deg, ${G50} 0%, ${G100} 100%`,
	`270deg, ${Y75} 0%, ${Y200} 100%`,
];
